import React, { useEffect } from "react";
import routes from "./routes";
import { PrivateRoute } from "./privateRoute";
import { Switch } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./App.css";
import { useHistory } from "react-router-dom";
import io from 'socket.io-client'
import { useIdleTimer } from 'react-idle-timer'
import { useDispatch } from "react-redux";
import axios from "axios";
import Cookies from 'js-cookie'
import { logout, updateUserStatus } from './redux/actions'

const App = (props) => {
  let history = useHistory();
  const dispatch = useDispatch();
  const options = { transports: ["websocket"], upgrade: false }
  const socket = io.connect(process.env.REACT_APP_SERVER_URL, options)
  // let user = useSelector((state) => state.userDetails);

  const handleOnAction = async () => {
    try {
      const token = Cookies.get('token');
      if (token) {
        console.log("token-front: ", token);
        const response = await axios.request({
          data: { token: token },
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token
          },
          url: `${process.env.REACT_APP_SERVER_URL}/v1/users/fetch-user`
        })

        if (response.data.success) {

          if (!response.data.data.is_active) {
            dispatch(logout())
          }
        }
      }
    }
    catch (error) {
      console.log(error);
    }
  }

  useIdleTimer({
    timeout: 1000 * 60,
    onAction: handleOnAction,
  })

  return (
    <React.Fragment>
      {/* <Suspense fallback={<FullPageLoader />}> */}
      <div className="wrapper">
        <Switch>
          {routes.map((route, index) => {
            return (
              <PrivateRoute
                key={index}
                path={route.path}
                exact={route.exact}
                access={route.access}
                roles={route.role}
                socket={socket}
                history={history}
                component={(props) => (
                  <route.layout {...props}>
                    <route.component {...props} />
                  </route.layout>
                )}
              />
            );
          })}
        </Switch>
      </div>
      {/* </Suspense> */}
    </React.Fragment>
  );
};

export default App;
